<template>
  <div class="col-sm-12 nopads">
    <div class="col-sm-12 editor-form" @click.stop="">
        <h3 class="editor-header">{{ modeUpdate.id > 0 ?  $t('work_time.edit_mode')  : $t('work_time.add_mode') }}</h3>
      <div class="col-sm-12 form-data">
        <span class="span-title">{{ $t('common.name') }}</span>
        <input
          id="name"
          v-model="modeUpdate.name"
          class="form-control form-control-sm"
          type="text"
        >
        <div class="row py-3">
            <div class="col-sm-4">
                <span class="span-title">{{ $t('work_time.type') }}</span>
                <div id="types">
                    <div
                        v-for="option in options"
                        :key="option.value"
                        class="form-check"
                    >
                        <input
                            :id="'type-option-' + option.value"
                            v-model="type"
                            class="form-check-input"
                            type="radio"
                            :name="'type-options'"
                            :value="option.value"
                        >
                        <label
                            class="form-check-label"
                            :for="'type-option-' + option.value"
                        >
                            {{ option.text }}
                        </label>
                    </div>
                </div>
            </div>

          <div v-if="type === 1" class="col-sm-4">
            <span class="span-title">{{ $t('work_time.tracing') }}</span>
            <div class="form-check">
              <input
                id="tracing"
                v-model="tracing"
                class="form-check-input pt-2"
                type="checkbox"
              >
              <label
                class="form-check-label text-light"
                for="onlyUserOwnedContracts"
              >
                {{ $t('work_time.location_tracing_enabled') }}
              </label>
            </div>
          </div>
          <div
            v-if="type === 1"
            class="col-sm-4 nopads"
          >
            <!-- Select area group-->
            <span class="span-title">{{ $t('contracts.area_group') }}</span>
              <select
                id="areaGroups"
                v-model="areaGroupId"
                class="form-select form-select-sm sm-3"
                :disabled="areaGroups.length < 1"
              >
                <option :value="null">
                  {{ $t('work_time.select_area_group') }}
                </option>
                <option
                  v-for="option in areaGroups"
                  :key="option.id"
                  :value="option.id"
                >
                  {{ option.name }}
                </option>
              </select>
          </div>
        </div>

        <div class="col-sm-12 d-flex justify-content-end">
          <button class="btn btn-secondary form-button" @click.stop="$emit('close')">
            {{ $t('common.cancel') }}
          </button>
          <button class="btn btn-success form-button" :disabled="loading" @click.stop="submit">
            {{ $t('common.save') }}
          </button>
        </div>
      </div>
    </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {workManagementHelper} from '../mixins/WorkManagementMixin'
import {restApi} from '../mixins/RestApiMixin'
import {inject} from "vue";

export default {
    name: 'WorkTimeModeEditor',
    mixins: [workManagementHelper, restApi],
    props: {
        mode: {
            type: Object,
            default: null
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            loading: false,
            group: null,
            groups: [],
            type: null,
            tracing: false,
            modeUpdate: this.jsonToItem(this.mode),
            options: [
                {text: this.$t('work_time.work_type'), value: 1},
                {text: this.$t('work_time.absent_type'), value: 2}
            ],
            areaGroups: [],
            areaGroupId: null
        }
    },
    watch: {
        type: function (value) {
            if (value !== 1) {
                this.tracked = false
                this.areaGroupId = null
            }
        }
    },
    mounted: function () {
        if (this.modeUpdate.id > 0) {
            if (this.modeUpdate.work_type) {
                this.type = 1
            } else if (this.modeUpdate.absent_type) {
                this.type = 2
            }
        }
        if (this.modeUpdate.tracked) {
            this.tracing = true
        }
        if (this.modeUpdate.area_group) {
            this.areaGroupId = this.modeUpdate.area_group.id
        }
        this.fetchAreaGroups();
    },

    methods: {
        setDefaultValues: function (mode) {
            if (mode.name === '') {
                this.showAlert(this.$t('inspectable_editor.invalid_name'))
                return undefined
            }
            mode.work_type = false
            mode.absent_type = false
            if (this.type === 1) {
                mode.work_type = true
                mode.area_group = this.areaGroupId ? {id: this.areaGroupId} : null
            } else if (this.type === 2) {
                mode.absent_type = true
                mode.area_group = null
            }
            mode.tracked = this.tracing
            return mode
        },

        submit: function () {
            let json = this.setDefaultValues(this.modeUpdate)
            if (json !== undefined) {
                this.loading = true
                if (this.modeUpdate.id < 1) {
                    this.restAdd(this.workTimeModeUrl, json, this.success, this.fail)
                } else {
                    this.restUpdate(this.workTimeModeUrl, json, this.success, this.fail)
                }
            }
        },

        success: function () {
            this.$emit('closeAndUpdate')
            this.loading = false
        },

        fail: function () {
            this.showAlert(this.$t('common.alert_update_failed'))
            this.loading = false
        },

        fetchAreaGroups: function () {
            this.areaGroups = []
            this.loading = true
            this.restFetchParams(this.areaGroupUrl, {no_geom: 1}, this.handleAreaGroupResponse)
        },
        handleAreaGroupResponse: function (response) {
            this.loading = false
            if (response != null) {
                this.areaGroups = response.data
            }
        },


    }
}
</script>
